import { render, staticRenderFns } from "./safe-records.vue?vue&type=template&id=637f244d&scoped=true"
import script from "./safe-records.vue?vue&type=script&lang=js"
export * from "./safe-records.vue?vue&type=script&lang=js"
import style0 from "./safe-records.vue?vue&type=style&index=0&id=637f244d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "637f244d",
  null
  
)

export default component.exports